import { useEffect } from "react";
import { useParams } from "react-router-dom";

export default function TwitterAuthorizationStatus() {
  const { status } = useParams();

  useEffect(() => {
    setTimeout(() => {
      window.close();
    }, 3000);
  }, []);

  return (
    <div className="fixed top-0 z-40 h-[100vh] w-[100vw] bg-primary px-4 py-24 text-white">
      <div className="mx-auto min-w-full max-w-full px-4 text-center">
        <h1 className="text-center text-3xl font-bold">{status === "success" ? "Thank You" : "Oops!"}</h1>
        <hr className="mx-auto mb-20 w-[60%] opacity-70" />
        <h1 className="text-3xl font-bold leading-8 tracking-tight">
          Twitter Account {status === "success" ? "Linked Successfully!" : "Linking Failed!"}
        </h1>
        <p className="mt-2 text-base text-gray-500">
          {status === "success"
            ? "You are now eligible to participate in Share Requests and collect rewards. You can close this page now."
            : "Try Again to link from platfrom."}
        </p>
        <hr className="mx-auto mb-4 mt-20 w-[70%] opacity-70" />
      </div>
    </div>
  );
}
